import { GetDemandsType } from "@/interface"
import useConnectWallet from "@/store/wallet/useConnectWallet"
import { useCallback, useState } from "react"

const useGetDemands = () => {
    // 存放数据
    const [demandsData, setData] = useState<GetDemandsType>({
        id: BigInt(0), // 订单ID
        amount: BigInt(0), // 金额
        totalReward: BigInt(0), // 累计收益
        startTime: BigInt(0), // 订单开始时间
        endTime: BigInt(0), // 订单结束时间（指满一年后，订单没有收益）
        lastTime: BigInt(0), // 最近一次提取时间
        monthlyRate: BigInt(0), // 月利率
        isWithdrawn: false // 是否已经提取本金
    })
    // loading
    const [demandsLod, setLoading] = useState(false)
    const { contractEvm: { FlexibleStaking }, address } = useConnectWallet()
    // 获取数据的方法
    const getDemands = useCallback(async (id: bigint) => {
        setLoading(true)
        if (FlexibleStaking) {
            try {
                // 获取到数据
                const data = await FlexibleStaking.demands(address, id)
                // 修改页码，获取到得到数据的最后一条，为下一次开始的页码
                setData(data)
                setLoading(false)
                return data
            } catch (e) {
                console.log('useGetDemands', e);
            }
        }
        setLoading(false)
    }, [FlexibleStaking, address,])
    return { demandsData, demandsLod, getDemands }
}

export default useGetDemands